<template>
  <div class="tw-w-screen sm:tw-w-100 tw-px-2">
    <div
      class=" tw-w-full tw-h-auto tw-bg-white tw-z-10 tw-rounded-large tw-pb-14 tw-px-6 tw-pt-8 tw-border tw-border-solid tw-border-black-50"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LgkModal'
}
</script>
